<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->

    <el-col :xs="8" :sm="8" :lg="8">
      <el-button type="normal" @click.prevent="goBack" class="ml-20" circle>
        <i class="el-icon-d-arrow-left"> </i>
      </el-button>
    </el-col>
    <el-col :xs="16" :sm="16" :lg="16" class="text-right">
     <el-button v-if="job.jobInfo.alreadySigned === 'no'" type="primary" @click.prevent="handleSign" class="mr-20">簽核 <i
          class="el-icon-s-claim"></i></el-button>

      <template v-if="job.todoInfo.status === 'close'">
        <el-popconfirm
          confirm-button-text="確定"
          cancel-button-text="取消"
          icon="el-icon-info"
          icon-color="red"
          title="確定作廢此筆資料嗎?"
          @confirm="handleInvalid(job.todoInfo.id)"
        >
          <el-button size="mini" type="danger" slot="reference" class="mr-10">作廢此單</el-button>
        </el-popconfirm>
      </template>
          
      <el-tag v-if="job.jobInfo.alreadySigned === 'yes'" type="warning" class="mr-20">已簽核</el-tag>
    </el-col>


    

    <!--    基本資料-->
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main class="mymain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>基本資料</span>
          </div>
          <div>
            <el-form class="myform" style="padding: 20px;">
              <el-row>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="人員：">
                    {{job.todoInfo.userObj.username}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="標題：">
                    {{job.todoInfo.title}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="填表日期：">
                    {{job.todoInfo.startDate | fmtDate}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="請款單編號：">
                    {{job.todoInfo.reqPayNo}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="申請金額：">
                    NTD{{job.todoInfo.totalPrice}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="付款對象：">
                    {{job.todoInfo.paymentObject}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="付款方式：">
                    {{job.todoInfo.paymentMethod | fmtPaymentMethod}}

                    <div v-if="job.todoInfo.paymentMethod === 'wire'">
                      <p>抬頭 : {{job.todoInfo.wireTitle}}</p>
                      <p>銀行 : {{job.todoInfo.wireBank}}</p>
                      <p>帳號 : {{job.todoInfo.wireAccount}}</p>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
      </el-main>
    </el-col>

   

    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main class="mymain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>請款項目資料</span>
          </div>
          <div>
            <el-table :show-header="true" :data="job.pettyCashHistory" empty-text="無資料" stripe :default-expand-all="true">
              
              <el-table-column label="項目">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}.
                </template>
              </el-table-column>
              <el-table-column label="金額">
                <template slot-scope="scope">
                 NTD{{ scope.row.itemPrice}}
                </template>
              </el-table-column>

              <el-table-column type="expand" width="50">
                <template slot-scope="scope">
                  <p class="ml-10 mt-10">項目內容:</p>
                  <p class="ml-10">
                    <div style="padding:8px; line-height: 1.5; ">
                      {{ scope.row.itemContent }}
                    </div>
                  </p>
                  
                  <p class="ml-10 mt-20" v-if="scope.row.fileListDisplay.size>0">附件:</p>
                  <ol>
                    <li v-for="f in scope.row.fileListDisplay" :key="f.id" class="mt-10">

                      <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                      <p v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>
                    </li>
                  </ol>
                </template>
              </el-table-column>

              
              
            </el-table>
          </div>

          <el-row>
              <el-col :xs="24" :sm="24" :md="16" style="margin: 20px;">
                <span>總計:</span>
                NTD{{job.todoInfo.totalPrice}}
              </el-col>
            </el-row>

        </el-card>
      </el-main>
    </el-col>
    
    <el-col :xs="24" :sm="24" :lg="24" v-if="job.jobInfo.status !== 'draft'" class="mt-20">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>簽核紀錄</span>
          </div>
          <div>
            <el-table :data="job.signoffHistory" empty-text="尚無簽核紀錄" stripe :default-expand-all="true">
              <el-table-column label="簽核時間" prop="updatedAt" width="150">
                <template slot-scope="scope">
                  <p>{{ scope.row.updatedAt | fmtDateTime }}</p>
                </template>
              </el-table-column>
              <el-table-column label="簽核人員" width="150">
                <template slot-scope="scope">
                  <p>{{ scope.row.signerObj.username }}</p>
                </template>
              </el-table-column>
              <el-table-column label="結果" prop="signResult">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.signResult === 'N' || scope.row.signResult === 'invalid'" type="danger">{{ scope.row.signResult | signResult }}</el-tag>
                  <el-tag v-else>{{ scope.row.signResult | signResult }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="" type="expand">
                <template slot-scope="scope">
                  <p style="padding-left: 10px;">簽核備註 : {{ scope.row.notes }}</p>
                </template>
              </el-table-column>
              
            </el-table>
          </div>
        </el-card>
      </el-main>
    </el-col>

  

    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->

    <el-dialog title="附件圖"
               :visible.sync="img.dialog"
               :width="dw">
        <div class="demo-image">
          <el-image
            style="width: 100%; max-width: 100%; height: 100%;"
            :src="img.url"
            fit="cover" lazy>
              <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i> 開啟中...
            </div>
            </el-image>
        </div>
        
     </el-dialog>

    <el-dialog title="簽核資訊"
               :visible.sync="signoff.dialog"
               :width="dw">

      <el-form :model="job.jobInfo" ref="signForm" :rules="signoff.rules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="簽核選擇" prop="signResult">
              <el-radio v-model="job.jobInfo.signResult" label="Y">同意</el-radio>
              <el-radio v-model="job.jobInfo.signResult" label="N">退回</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="備註" prop="notes">
              <el-input rows="5" type="textarea" v-model="job.jobInfo.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="signoff.dialog = false">取 消</el-button>
        <el-button type="primary" @click="sendSignoff('signForm')">確 定</el-button>
      </div>
    </el-dialog>
   
  </el-row>


</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import debounce from 'lodash/debounce'
import dayjs from "dayjs";

export default {
  name: "TodoDetailDivMgrReview",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
        if (value === '' || value === null) {
          callback(new Error('請輸入資料'))
        } else {
          callback()
        }
      }
      let checkRadio = (rule, value, callback) => {
        console.log("checkRadio:", rule, value)
        if (value === '' || value === null) {
          callback(new Error('請選擇同意或退回'))
        } else {
          callback()
        }
      }

    return {
      dw: '50%',

      img:{
        dialog: false
      },

      signoff:{
        dialog: false,
        notes: '',
        rules: {
          signResult: [{required: true, validator: checkRadio, trigger: 'change'}]
        }
      },
      job:{
        id:'',
        jobInfo:{
          id:'',
          alreadySigned:'no'
        },
        todoInfo:{
          userObj:{}
        },
        divMgrHistory:[],
        customerHistory:[],
        pettyCashHistor:[],
        signoffHistory:[]
      },
    }
    
  },
  methods:{
    showImage(uuid) {
      this.img.dialog = true
      this.img.url = this.displayAvatar(uuid)
    },
    findJobContent() {
      this.request.get("/job/detail/" + this.job.id).then(res => {
        if (res.code === '200') {
          this.job = res.data
        }
      })
    },
    goBack() {
      this.$router.push('/message/my-signoff')
    },
    handleSign() {
      this.signoff.dialog = true
      this.signoff.notes = ''
    },

    handleInvalid(id) {
      this.request.post("/todo/invalid/" + id).then(res => {
          if (res.code === '200') {
            this.$router.go()
            this.showResult('success', '資料作廢成功.')
          } else {
            this.showResult('error', '資料作廢失敗.')
          }
      })
    },
    sendSignoff(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.request.post("/job", this.job.jobInfo).then(res => {
            if (res.code === '200') {
              this.showResult('success', '完成簽核')
              this.signoff.dialog = false
              this.$router.push('/message/my-signoff')
            } else {
              this.showResult('error', '簽核結果儲存失敗')
            }
          })
        }
      })
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = '400' // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = '90%'
      } else {
        this.dw = '50%'
      }
    },
    
  },
  mounted(){
    this.job.id = this.$route.params.jobId
    // console.log("this.form.id:", this.job.id)

    this.findJobContent()
    this.setDialogWidth();
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.myform >>> .el-form-item__label {
  padding: 0;
}

main >>> .el-card__body {
  padding: 0px;
}

.mymain >>> .el-form-item {
  margin-bottom: 0;
}

.myform >>> .el-form-item__label {
  padding: 0px;
}
.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 12px;
}

.taskMain >>> .el-card__body {
  padding: 0;
}
.el-table {
  padding: 0;
}
.mymain >>> .el-form-item__label,
.mymain >>> .el-form-item__content {
  line-height: 28px;
}
</style>
